import { useEffect, useState } from "react";
import { RxCross1, RxCross2 } from "react-icons/rx";
import { Button, Input, Modal, ModalBody } from "reactstrap";
import SliderInput from "./SliderInput";

const PeopleInRadiusSelect = ({ isOpen, setisOpen, onSuccess }) => {
  const [randomTotalPeople, setRandomTotalPeople] = useState(0);
  const [rangeSelected, setRangeSelected] = useState(0);

  useEffect(() => {
    let numbers = Number(rangeSelected) * 2;
    setRandomTotalPeople(numbers);
  }, [rangeSelected]);

  return (
    <Modal
      centered
      size="md"
      fade={false}
      isOpen={isOpen}
      toggle={() => setisOpen((prev) => !prev)}
    >
      <ModalBody
        className="bg-white p-lg-4"
        style={{
          borderRadius: "40px",
          animation: "slide-from-above 0.3s linear 1",
        }}
      >
        <div className="d-flex px-3 ">
          <Button
            className="rounded-white-btn p-0 text-black border-none"
            style={{
              "--radius": "32px",
              aspectRatio: 1,
              transform: "translateY(-20%)",
            }}
          >
            <RxCross2 size={17} />
          </Button>
          <h4 className="m-0 text-center full-width f-6 figma-shadowed-black-text px-lg-3">
            Sent Push Notification to Nearby People
          </h4>
        </div>
        <div className="p-3">
          <p className=" text-center mt-2 mb-5">
            Available people in the selected radius will get push notification
            of your event. Are you agree to continue
          </p>
          <h5 className="f-6 text-center mb-3 ">People in Radius</h5>
          <h1 className="f-6 text-center m-0">{randomTotalPeople}</h1>
        </div>
        <div className="px-4">
          <SliderInput
            max={100}
            min={1}
            unitValue={"km"}
            setValue={setRangeSelected}
            value={rangeSelected}
          />
          <div className="px-2 mt-5">
            <Button
              onClick={() => onSuccess()}
              style={{ borderRadius: "200px" }}
              className="standard-rounded-btn mb-3 d-block full-width border-none"
            >
              Pay $5.00
            </Button>
            <Button
              onClick={() => setisOpen(false)}
              style={{ borderRadius: "200px" }}
              className=" bg-transparent full-width d-block py-3 color-primary-blue border-primary-blue"
            >
              Cancel
            </Button>
          </div>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default PeopleInRadiusSelect;
